<template>
   <div>
        <div class="product-window coupon" :class="cartOpen === true ? 'on' : ''">
            <div class="page-text-center movie-box page-relative title">
                <span class="iconfont icon-guanbi page-absolute" @click="closeAttr"></span>
                <span class="font-size28 font-weight650">卡券管理</span>
            </div>
            <div class="movie-wrapper content-wrap">
                <!-- 新增卡券 -->
                <div class="movie-box page-text-center font-size28 page-background-color-white add-cou" @click="addNewCoupon">+新增卡券</div>
                <!-- 专区列表 -->
                <SelectZone :data="datas" @removeCou="removeCou" @selectPart="selectPart" ></SelectZone>
            </div>
        </div>
        <div
          class="mask"
          @touchmove.prevent
          :hidden="cartOpen === false"
          @click="closeAttr"
        ></div>
   </div>
</template>

<script>
import SelectZone from "@components/SelectZone";
export default {
    name: "ProductCouponWindow",
    components: {
        SelectZone
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: ()=>[]
        }
    },
    watch: {
        isOpen: function (val) {
            console.log()
            this.cartOpen = val;
        },
        data: function (val) {
            this.datas = val;
        }
    },
    data: function () {
        return {
            cartOpen: false,
            datas: []
        }
    },
    methods: {
        closeAttr() {
            this.cartOpen = false;
            this.$emit('closeAttr', false);
        },
        removeCou(id) {
            this.$emit('removeCouFn', id);
        },
        addNewCoupon() {
            this.$emit('addNewCoupon', true);
        },
        selectPart(item) {
            this.$emit('selectPartFn', item);
        }
    }
}
</script>

<style scoped lang="scss">
.coupon {
    height: 10rem;
    padding-bottom: 0.6rem;
    background: #EFEFEF;
    .title {
        height: .8rem;
        line-height: .8rem;
        .iconfont {
            right: .2rem;
            font-size: 0.28rem;
        }
    }
    .content-wrap {
        height: 100%;
        overflow-y: scroll;
        padding-bottom: .4rem;
        .add-cou {
            height: 0.76rem;
            line-height: 0.76rem;
            border-radius: 0.08rem;
            margin-bottom: 0.16rem;
        }
    }
}
</style>